import { render, staticRenderFns } from "./UpsellCart.vue?vue&type=template&id=5bcc92b2&scoped=true&"
import script from "./UpsellCart.vue?vue&type=script&lang=js&"
export * from "./UpsellCart.vue?vue&type=script&lang=js&"
import style0 from "./UpsellCart.vue?vue&type=style&index=0&id=5bcc92b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc92b2",
  null
  
)

export default component.exports